import { z } from 'zod';

/**
 * Sign-in failures the login page can render. The first three are produced by
 * the server's Microsoft callback redirect (`/login?error=…`, see
 * `apps/server/src/modules/auth/auth-failure.ts`); `session_expired` is set by
 * the client when a stored token stops being accepted.
 */
export const authErrorSchema = z.enum([
  'access_denied',
  'invalid_state',
  'auth_failed',
  'session_expired',
]);

export type AuthError = z.infer<typeof authErrorSchema>;

const MESSAGES: Record<AuthError, string> = {
  access_denied:
    'Sign-in was cancelled. Approve the Microsoft prompt to continue.',
  invalid_state:
    'That sign-in link expired or was already used. Please try again.',
  auth_failed:
    'We could not sign you in with Microsoft. Please try again, or contact support if this keeps happening.',
  session_expired: 'Your session expired. Please sign in again.',
};

export function authErrorMessage(error: AuthError): string {
  return MESSAGES[error];
}
